<template>
  <div class="not-found container py-5 text-center">
    <p class="not-found__code mb-2">404</p>
    <h1 class="mb-3">Page introuvable</h1>
    <p class="text-muted mb-4">
      La page que tu cherches n'existe pas ou a été déplacée !
    </p>
    <b-button variant="primary" @click="$router.push('/')">
      Retour à l'accueil
    </b-button>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style scoped>
.not-found {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.not-found__code {
  font-size: 4rem;
  font-weight: 700;
  line-height: 1;
  color: #5e72e4;
}
</style>
